import React, { useState } from 'react';
import { Target, ClipboardList, Settings2, FileText, BarChart3, ChevronLeft } from 'lucide-react';
import { AtlasUser } from '../shared/atlasApi';
import MinhasAvaliacoes from './MinhasAvaliacoes';
import Responder from './Responder';
import Ciclos from './Ciclos';
import Formularios from './Formularios';
import Resultado from './Resultado';

interface Props {
  user: AtlasUser;
  podeEditar: boolean;
  isAdmin: boolean;
}

type SubView = 'minhas' | 'ciclos' | 'formularios' | 'resultados';

const Desempenho: React.FC<Props> = ({ user, podeEditar, isAdmin }) => {
  const gestao = isAdmin || podeEditar;
  const [subview, setSubview] = useState<SubView>('minhas');
  const [responder, setResponder] = useState<{ cicloId: string; funccodi: number } | null>(null);
  const [resultadoSel, setResultadoSel] = useState<{ cicloId: string; funccodi: number } | null>(null);

  const TABS: { id: SubView; label: string; icon: React.ReactNode; show: boolean }[] = [
    { id: 'minhas', label: 'Minhas avaliações', icon: <ClipboardList className="w-4 h-4" />, show: true },
    { id: 'ciclos', label: 'Ciclos', icon: <Settings2 className="w-4 h-4" />, show: gestao },
    { id: 'formularios', label: 'Formulários', icon: <FileText className="w-4 h-4" />, show: gestao },
    { id: 'resultados', label: 'Resultados', icon: <BarChart3 className="w-4 h-4" />, show: gestao },
  ].filter(t => t.show);

  const trocar = (id: SubView) => { setSubview(id); setResponder(null); setResultadoSel(null); };

  // Tela de responder (a partir de "Minhas avaliações").
  if (responder) {
    return (
      <div className="p-6 space-y-4 max-w-5xl">
        <button onClick={() => setResponder(null)} className="text-sm text-gray-500 hover:text-purple-600 flex items-center gap-1"><ChevronLeft className="w-4 h-4" /> Voltar</button>
        <Responder user={user} cicloId={responder.cicloId} avaliadoFunccodi={responder.funccodi} onConcluir={() => { setResponder(null); setSubview('minhas'); }} />
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4 max-w-5xl">
      <div className="flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center"><Target className="w-5 h-5" /></div>
        <div className="flex-1">
          <h2 className="text-lg font-bold text-gray-900">Avaliação de Desempenho</h2>
          <p className="text-sm text-gray-500">Ciclos de avaliação, competências e resultados.</p>
        </div>
      </div>

      <div className="flex gap-1 border-b border-gray-200">
        {TABS.map(t => (
          <button
            key={t.id}
            onClick={() => trocar(t.id)}
            className={`px-4 py-2 text-sm font-medium flex items-center gap-2 border-b-2 -mb-px transition ${
              subview === t.id ? 'border-purple-600 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {t.icon}{t.label}
          </button>
        ))}
      </div>

      {subview === 'minhas' && (
        <MinhasAvaliacoes user={user} onResponder={(cicloId, funccodi) => setResponder({ cicloId, funccodi })} />
      )}
      {subview === 'ciclos' && gestao && (
        <Ciclos user={user} onVerResultado={(cicloId, funccodi) => { setResultadoSel({ cicloId, funccodi }); setSubview('resultados'); }} />
      )}
      {subview === 'formularios' && gestao && (
        <Formularios user={user} podeEditar={podeEditar} />
      )}
      {subview === 'resultados' && gestao && (
        <Resultado user={user} cicloId={resultadoSel?.cicloId} funccodi={resultadoSel?.funccodi || undefined} />
      )}
    </div>
  );
};

export default Desempenho;
